export const huaColorMaps: Record<string, { [level: number]: [number, number, number, number] }> = {
  bk: {
    1: [69, 102, 138, 0.8],
    2: [94, 167, 159, 0.8],
    3: [123, 196, 142, 0.8],
    4: [181, 226, 155, 0.8],
    5: [255, 255, 191, 0.8],
  },
  nchv: {
    1: [69, 102, 138, 0.8],
    2: [94, 167, 159, 0.8],
    3: [123, 196, 142, 0.8],
    4: [181, 226, 155, 0.8],
    5: [255, 255, 191, 0.8],
  },
  hh: {
    1: [69, 102, 138, 0.8],
    2: [94, 167, 159, 0.8],
    3: [123, 196, 142, 0.8],
    4: [181, 226, 155, 0.8],
  },
  ewb: {
    1: [69, 102, 138, 0.8],
    2: [94, 167, 159, 0.8],
    3: [123, 196, 142, 0.8],
    4: [181, 226, 155, 0.8],
    5: [255, 255, 191, 0.8],
  },
  nt: {
    1: [69, 102, 138, 0.8],
    2: [94, 167, 159, 0.8],
    3: [123, 196, 142, 0.8],
    4: [181, 226, 155, 0.8],
    5: [255, 255, 191, 0.8],
  },
  hqi: {
    1: [247, 252, 253, 255],
    2: [204, 236, 230, 255],
    3: [102, 194, 164, 255],
    4: [35, 139, 69, 255],
    5: [0, 68, 27, 255],
  },
  totales: {
    1: [69, 102, 138, 0.8],
    2: [94, 167, 159, 0.8],
    3: [123, 196, 142, 0.8],
    4: [181, 226, 155, 0.8],
    5: [255, 255, 191, 0.8],
  },
};

export const huaBundlesColorMaps: Record<string, { [level: number]: [number, number, number, number] }> = {
  current: {
    1: [64, 0, 75, 51],
    2: [174, 139, 189, 51],
    3: [247, 247, 247, 255],
    4: [128, 197, 129, 51],
    5: [0, 68, 27, 51],
  },
  development: {
    1: [64, 0, 75, 51],
    2: [174, 139, 189, 51],
    3: [247, 247, 247, 255],
    4: [128, 197, 129, 51],
    5: [0, 68, 27, 51],
  },
  conservation: {
    1: [64, 0, 75, 51],
    2: [174, 139, 189, 51],
    3: [247, 247, 247, 255],
    4: [128, 197, 129, 51],
    5: [0, 68, 27, 51],
  },
  utopia: {
    1: [64, 0, 75, 51],
    2: [174, 139, 189, 51],
    3: [247, 247, 247, 255],
    4: [128, 197, 129, 51],
    5: [0, 68, 27, 51],
  },
  repower: {
    1: [64, 0, 75, 51],
    2: [174, 139, 189, 51],
    3: [247, 247, 247, 255],
    4: [128, 197, 129, 51],
    5: [0, 68, 27, 51],
  },
};
